/* eslint-disable */

export const talks = [ {
    id: "0d26e13c-fd89-4999-9e8c-8fc491a58bd5",
    description: "Not so long ago we realized that it was better to write programs in C, Python or Java that continue writing them in assembler. We learn to delegate in the compilers the burden of many repetitive, low-level tasks. It all started with simple tasks, but as compilers become more and more advanced, even complex concerns such as memory management are handled by them. That allowed us to be more productive, achieve more in the same time, and write programs that were more robust. Yes, the compilers outperform us in many, many tasks. The challenge that we have nowadays with generative AI, and more specifically, with coding agents, is not that different, right? However, we are afraid of “giving free rein“ to AI agents, and its logical. We are afraid of such earth-shaking change. AI is a phenomenal opportunity to become more than we are. “Let it go“ of all the tasks that do not provide a significant added value. Let's focus more on defining “executable and verifiable“ specifications and let the machine take care of code and testing for us (if not all, on a significant portion of tasks). Code is just another level of abstraction, even if some that we are too fond of. This is the moment that have dreamed about: to be able to deliver whole projects or specific features always on time and with the expected levels of quality, and from that point onwards, to be “the best that there is at what we do“. Let's explore together how this is becoming a reality. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["03255126-a9e1-4873-a5c4-d6ab97a6d207"],
    title: "Codingeddon: The end of Software Engineering as we know it",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/wZs8ixkqlOo",
    updated: "2025-06-16T10:09:01.689Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "10:30"
    ,
    endTime: "11:10"
    ,
    trackInDay: 1
}, {
    id: "9b024ba2-118f-488e-9411-b983a01c4107",
    description: "Initial conversation around Accenture's platform security capabilities with a focus on SAP security. We will explore the latest challenges and innovations in SAP security. With digital transformation accelerating across industries, having a robust SAP security strategy is more critical than ever. Accenture and Bowbridge will provide attendees with cutting-edge knowledge and actionable strategies to protect their SAP landscapes. with an highlight of offering provided by Bowbridge. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "expert",
    speakers: ["50c7b9b3-c5d4-4736-ae7c-2c33122420a6", "9b8a41a7-1ee9-47e3-b3b9-7ff2211a867f"],
    title: "Accenture & Bowbridge collaboration – Secure your SAP solutions with confidence ",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/8WhnsaueMR8",
    updated: "2025-08-14T09:38:32.305Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:50"
    ,
    endTime: "16:30"
    ,
    trackInDay: 5
}, {
    id: "debb4aa0-37db-4d87-8c94-2bcf2dfedbcb",
    description: "Remix is a modern React-based framework, driving web apps such as ChatGPT.com or Shopify. Its focus is on performance, simplicity and maximum use of web standards. The React Router project has been merged with Remix, now with the common name React Router 7, while keeping backwards compatibility. You will use the TypeScript language to build a small but complete web application, including front-end, back-end, database, and authentication. You will use Zod and Drizzle ORM to make sure the data are valid and type-safe across the stack. We will show you how to host your app for free. It is encouraged (but not required) to use your AI-driven development environment. Previous experience with JavaScript is required.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "intermediate",
    speakers: ["25cd3339-d98a-47d6-9d3f-2aa759eb4710", "de2c9102-fe35-4d84-9427-1f20e7837c14"],
    title: "Building full-stack applications with Remix / React Router 7",
    track: "Interactive 3-hour Hands-on Lab",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "Room 3",
    youtube: "",
    updated: "2025-09-12T09:15:36.919Z"
    ,
    order: 1
    ,
    conferenceDay: "day1"
    ,
    startTime: "12:00"
    ,
    endTime: "14:30"
    ,
    trackInDay: 3
}, {
    id: "25b7a6df-3db6-47f1-9355-24aa09be10da",
    description: "Gen AI agents can apply artificial intelligence to cooperate with each other and solve complex problems. While most of the GenAI agent examples and demos are happening in virtual space, in my presentation I would showcase how to make an agent out of a small robot. Thanks to the MCP protocol, we will make the robot functionality available for the LLM and let it act as an agent within an agentic workflow, interact with other agents available, but also navigate the real environment around it. With this example we'll showcase some of the main components of the agentic architecture and how it can cooperate with a real world.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "intermediate",
    speakers: ["dae28908-c771-4756-bc70-dc3b47dbdd0a"],
    title: "Making a robot agent",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/PhbOZmoazuU",
    updated: "2025-09-01T18:02:07.826Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:50"
    ,
    endTime: "14:30"
    ,
    trackInDay: 1
}, {
    id: "de9ade6d-2f51-44ae-8f9f-bb630b72aa9e",
    description: "You are way beyond clone, commit and push. Resolving conflicts is also not an issue. But what happens when you are deep in detached HEAD, your rebase goes off the rails, you need to work across dozens of repositories, or you need to surgically rewrite history across hundreds of commits? This hands-on workshop explores the powerful corners of git suitable for seasoned maintainers. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "everyone",
    speakers: ["6421e779-7c1e-40c8-8d05-88ba9949e2d6"],
    title: "Git You Don't Know",
    track: "Interactive 3-hour Hands-on Lab",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "Room 3",
    youtube: "",
    updated: "2025-07-08T13:49:38.927Z"
    ,
    order: 1
    ,
    conferenceDay: "day1"
    ,
    startTime: "09:00"
    ,
    endTime: "11:30"
    ,
    trackInDay: 3
}, {
    id: "9020cbfd-d0c1-4417-842b-a7f23cafd36b",
    description: "Enterprise cloud automation can quickly become complex especially when dealing with multiple cloud providers, internal teams, and ever-changing services. This talk will share practical lessons on building automation that stays reliable, maintainable, and secure over time. We’ll explore how to avoid overcomplicating your automation, keep technology choices under control, and maintain consistency across teams. You’ll also learn how to decide what’s worth automating, handle services with limited automation support, and protect your automation across different platforms. We'll also talk about the benefits, and risks, of using GenAI in this process.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "expert",
    speakers: ["808762d8-e990-405c-85b0-6def2cd19d7c"],
    title: "Taming the Multi Cloud: Automating Enterprise Infrastructure Without Losing Control",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/OzasnWPuMPo",
    updated: "2025-07-03T12:35:25.474Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:50"
    ,
    endTime: "14:30"
    ,
    trackInDay: 4
}, {
    id: "8c54e7bf-0937-438a-be83-80d2a2dd3232",
    description: "In a world increasingly shaped by generative AI, the role of software engineers is evolving rather than disappearing. While AI can generate code, test cases, and even architectural suggestions, engineers remain essential as the critical thinkers who design robust systems, ensure quality, and integrate ethical and human-centered considerations. The future of software engineering will involve collaborating with AI as a partner—leveraging its ability to accelerate routine tasks while focusing human expertise on problem framing, complex system design, and innovation. For IT students, this means developing not only strong technical foundations but also adaptability, creativity, and a deep understanding of how to responsibly apply AI in building the next generation of software. For companies, it means reimagining software engineering as a strategic advantage—where human talent and generative AI work together to deliver faster innovation, higher quality, and more resilient digital solutions.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["8f6ed052-f005-4673-8df4-4d4e37a4657a"],
    title: "Software Engineering role in a genAI dominated world",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/-4fNKfLZKSY",
    updated: "2025-09-02T11:11:56.432Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:00"
    ,
    endTime: "13:40"
    ,
    trackInDay: 4
}, {
    id: "dc9eaf84-19a0-452a-a2e1-dfed104123dd",
    description: "To realize the full promise of AI, we need it to act in the moment. Yet, our most valuable data is often locked away, primarily serving after the fact analysis. This session presents a new vision: treating data not as a historical record, but as the real time fuel for intelligent action. We will explore how to architect high quality Data Products that serve as the foundation for this new paradigm. This approach powers ecosystems of collaborative AI Agents that respond to events as they unfold, driving dynamic processes, enabling quicker decisions, and creating delightful customer experiences. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["46d558c7-28c2-48c7-b355-b1ec9ad9a2bb"],
    title: "Data Products as Fuel for AI Agents: Powering the Autonomous Enterprise",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/2E-k30R02gA",
    updated: "2025-08-04T16:01:57.669Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "09:30"
    ,
    endTime: "10:00"
    ,
    trackInDay: 1
}, {
    id: "737e70fd-321c-40db-b26d-f382b4e0791b",
    description: "Modern language technologies, including large language models like ChatGPT, Claude or LLAMA, are of great interest to both researchers and industrial innovators. This workshop will explain the basic concepts and building blocks behind these technologies, as well as how they can be applied in more complex scenarios, such as retrieval-augmented generation (RAG). We will also review several practical examples that demonstrate useful tools and libraries.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "intermediate",
    speakers: ["7de1d2a4-b7c8-4d37-93ac-c5c6022a6035"],
    title: "How to work with Language technologies: Practical approach",
    track: "Interactive 3-hour Hands-on Lab",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "Room 1",
    youtube: "",
    updated: "2025-08-06T07:28:59.623Z"
    ,
    order: 1
    ,
    conferenceDay: "day1"
    ,
    startTime: "12:00"
    ,
    endTime: "14:30"
    ,
    trackInDay: 1
}, {
    id: "252b5585-377b-4cb9-bc67-061ac961b408",
    description: "This talk explores the emerging field of AI agents - autonomous systems built on large language models (LLMs) that are designed to reason, plan, and act in pursuit of specific goals. We’ll break down what an AI agent is, how it differs from traditional LLM usage, and why it represents a major evolution in applied AI. Key concepts like Retrieval-Augmented Generation (RAG), tool calling, and model context protocol (MCP) will be introduced to show how agents extend the functionality of LLMs beyond single-turn prompts. We’ll also compare agent-based systems with conventional pipelines and discuss how Multi-Agent Systems (MAS) enable more complex coordination and task handling. To ground the concepts, we’ll showcase illustrative examples of agents built using an agent framework,  highlighting how straightforward it can be to design and deploy your own agents. Along the way, we’ll explore the tools and technologies that make this possible, providing a practical foundation for anyone looking to experiment with AI agents in their own work.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["d03717b3-56c3-43fb-aaf9-09b70a5053de"],
    title: "AI Agents: Evolving Beyond Single-Turn Prompts",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/yhDrN_uQzf0",
    updated: "2025-08-06T13:26:55.190Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:50"
    ,
    endTime: "14:30"
    ,
    trackInDay: 2
}, {
    id: "f24252ab-90d6-4be9-b216-0654ca568c18",
    description: "Experience how a leading financial services provider modernized a core legacy application with GenAI in record time. By strategically leveraging Accenture GenWizard for intelligent code analysis and Pega Blueprint for accelerated redevelopment, a functional MVP was created within a very short period, transforming complex legacy structures into structured artifacts. The result: significantly reduced effort for subject matter experts, markedly faster reverse and forward engineering, and greatly improved time-to-market and compliance assurance. This session will showcase how modern technologies not only replace legacy systems, but also create real business value – quickly, securely, and at scale.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["00804265-6f24-44a7-9f00-218b52c2b651", "1ca57305-2591-4855-8cf4-25c970ef0265", "5998d346-2dd5-4445-8b51-b5cac45238d9"],
    title: "Legacy-Modernization with GenAI – From Vision to Reality",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/PDbvsKmdMnM",
    updated: "2025-09-11T06:57:29.363Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:00"
    ,
    endTime: "15:40"
    ,
    trackInDay: 1
}, {
    id: "8cd49786-83d5-4f5f-9762-065891a4d92b",
    description: "In the fast-evolving world of software engineering, “vibe coding“ is revolutionizing how developers prototype and build applications—describing ideas in natural language and letting AI handle the heavy lifting of code generation, debugging, and deployment. But turning those vibes into scalable, production-ready systems? That's where AWS shines. Join us for a dive into vibe coding powered by AWS's cutting-edge tools like Amazon Q Developer, the agentic IDE Kiro, and MCP servers, designed to supercharge your workflows while embedding security, cost optimization, and best practices from the start.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["f4d7cc2e-a9dc-4faf-9e46-94a803dff6c1"],
    title: "Talk it, Build it: Vibe Coding meets AWS for Next-Gen Development",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/Oq9yUtYZ25M",
    updated: "2025-09-01T14:30:47.052Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "10:30"
    ,
    endTime: "11:10"
    ,
    trackInDay: 3
}, {
    id: "092b9100-89b4-44f7-b5b9-7dac375dc1db",
    description: "The interactive workshop will guide participants through the use of Event Storming to uncover and refine enterprise data models. Attendees will learn how to identify domain events, align business and technical stakeholders, and design services that reflect real-world processes. The workshop will explore the value of collaborative modeling in building scalable, event-driven systems and highlighted practical techniques for translating insights into actionable service designs.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["021051c7-2943-4676-9c60-f143d030d9c2", "11e5ddd1-662d-43c6-820b-c403073977ba", "a65c113f-0540-4381-93db-f3f011d9951c"],
    title: "Unlocking Your Data Model in Event Storming Workshops",
    track: "Interactive 3-hour Hands-on Lab",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "Room 2",
    youtube: "",
    updated: "2025-09-10T14:18:46.863Z"
    ,
    order: 1
    ,
    conferenceDay: "day1"
    ,
    startTime: "15:00"
    ,
    endTime: "17:30"
    ,
    trackInDay: 2
}, {
    id: "3045aa65-acd5-458c-b850-133de42ceb7f",
    description: "You’ve deployed the tools. But are they helping? Theres is a number of challenges that are the most persistent pain points security teams encounter when implementing and operating security platforms. These include pain points like Alert overload, the sheer volume of alerts generated by security tools after deployment can be overwhelming to teams, especially with no unified context; Lack of visibility across cloud estates, many organizations struggle to gain a unified view of all their vulnerabilities across their entire cloud environment; Process roadblocks, Sometimes cultural, political and social challenges can impact process and create worse security outcomes in large organizations; Underutilization of security platforms, even with the most advanced security tools, some teams do not fully leverage the full capabilities of the platform; Recurring vulnerabilities, after fixing vulnerabilities, some security teams encounter the same issues reappearing; Migration challenges, organizations know a unified platform is key to gaining clear visibility and control in the cloud, but shifting from siloed tools can feel complex. Stop chasing alerts, start securing your cloud.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["5be43200-0a62-4dd8-8642-7de901f2e529", "d4cd883b-d2fd-48a0-bc71-de704106898d"],
    title: "Global, AI-powered protection. Together, we secure your digital core.",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/6xdP5kX5LUk",
    updated: "2025-09-05T08:15:11.900Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:50"
    ,
    endTime: "14:30"
    ,
    trackInDay: 5
}, {
    id: "52acf53e-1e93-428e-899a-4a531c45e809",
    description: "As Agentic AI systems gain autonomy, the lack of identity frameworks poses serious risks to governance, traceability, and policy enforcement. This talk explores the architectural necessity of binding identity to agents before they act. Without identity, agents become unaccountable actors, making it impossible to audit decisions, enforce constraints, or revoke access. We’ll examine technical strategies for embedding identity into agent design, including cryptographic tagging, decentralized identifiers, and policy-aware execution environments that can be used to provide integrity and auditability. Attendees will gain insights into how identity can enable control, trust, and compliance in distributed AI ecosystems.  ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["1fcd64ef-c485-4ea7-ae25-9711a90ce2b6"],
    title: "From Chaos to Compliance: Why Agent Identity Is the Next Business Imperative",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/5PAo9AQG3Uk",
    updated: "2025-09-19T13:47:36.524Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:00"
    ,
    endTime: "15:40"
    ,
    trackInDay: 5
}, {
    id: "d6fa8501-d4fb-45d9-a853-57772d5f0083",
    description: "The talk focuses on the use of genAI agents in software testing. We will show how AI agents can effectively interpret e.g. Gherkin scenarios, generate test cases and automate testing via Cucumber. We will discuss the benefits of Behavior-Driven Development (BDD) in combination with artificial intelligence, including faster error detection, better readability of tests and adaptation to changes in the system. The talk includes practical demonstrations where AI agents automatically create and execute tests based on simple business requirements. In the second part, we will look at test automation in genAI applications and their evaluation.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "everyone",
    speakers: ["50b9477f-95e7-4a8c-8b6d-672ecb0b2cbd"],
    title: "Cucumber and Gherkin, AI agents with permission to test",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/I3svmzzGy8g",
    updated: "2025-06-12T09:26:55.132Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:00"
    ,
    endTime: "15:40"
    ,
    trackInDay: 3
}, {
    id: "fc3786d9-f848-4982-a9e7-2c8ef173c5e1",
    description: "This lab will explore the role of Web Application Firewalls (WAFs) and the evolution of defensive techniques designed to complicate system exploitation. Participants will first dive into various evasion methods, starting with basic techniques like bypassing input validations on specific HTTP request areas or using alternative ways to represent body of HTTP request. The session will then compare different WAF solutions, examining their configuration options and request parsing mechanisms. Attendees will test the same payload across various solutions, highlighting the differences in how each solution handles the same request. This will include an exploration of how different WAFs handle oversized requests and their impact on bypass attempts. Next, we’ll move into practical exercises focusing on JavaScript-specific quirks, such as function call variations and grammar parsing issues. Participants will practice evading rules that detect special characters or whole constructions, by leveraging learned quirks. The lab will also cover various techniques for encoding payloads within both HTTP requests and JavaScript, helping to bypass security measures. Finally, we will wrap up the session with a showcasing fuzzing techniques for WAF bypass and how to defeat WAF solutions that employ text transformation defenses. The lab is aimed at both WAF configuration professionals and offensive security specialists. The lab should inspire further exploration into WAF defenses, payload evasion techniques, and security configurations.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "intermediate",
    speakers: ["16a64f61-858a-43cb-b1e1-d3a6b185964e", "326cd898-aa3f-48a0-8b14-260aa8cb2d39"],
    title: "Bypassing Web Application Firewalls and Defensive Measures – Insights from Penetration Testing and Bug Bounty Hunting",
    track: "Interactive 3-hour Hands-on Lab",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "Room 1",
    youtube: "",
    updated: "2025-08-14T14:25:30.447Z"
    ,
    order: 1
    ,
    conferenceDay: "day1"
    ,
    startTime: "09:00"
    ,
    endTime: "11:30"
    ,
    trackInDay: 1
}, {
    id: "3653f10a-0df9-41da-a8a0-fc41d1833a19",
    description: "Traditional risk methods like ISO 27005 often lack the context and clarity needed for strategic decisions. This session presents EBIOS Risk Manager as a practical tool for aligning cybersecurity actions with business risk. Using a case study on remote access to OT systems, we’ll show how EBIOS RM helps identify credible attack scenarios, prioritize investments, and support security-by-design in high-stakes environments.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["3b428ba1-29b9-485a-bb71-3a484d977bd8"],
    title: "Think Like an Attacker: EBIOS Risk Manager for Security by Design",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/PHc1THNQCy4",
    updated: "2025-08-14T14:43:28.045Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "11:20"
    ,
    endTime: "12:00"
    ,
    trackInDay: 5
}, {
    id: "bbfea846-ce9e-4403-8df3-3cf4d0d2acf3",
    description: "In the era of AI-powered decision support, ensuring the reliability and robustness of generative models is critical—especially in sensitive domains like insurance underwriting. In this session, we’ll walk through our methodology for evaluating Gen AI performance in Life Guide Scout, a tool designed to assist underwriters in assessing life and health-related risks. You'll gain insight into how we test the AI’s consistency, factual accuracy, and trustworthiness when answering complex medical and lifestyle-related queries—like evaluating the risk profile of a smoker with pre-existing conditions. Join us to explore what it takes to make Gen AI not just smart, but reliable.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["8deef576-1486-45fd-9f90-57f8ad4b6a43"],
    title: "Stress Testing the Mind of the Machine: Evaluating Gen AI Reliability in Underwriting",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/qA128znbfU8",
    updated: "2025-07-16T14:53:15.114Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:00"
    ,
    endTime: "13:40"
    ,
    trackInDay: 1
},  {
    id: "d045c782-cfbf-4ca8-b16f-27563a53ebcb",
    description: "What if repositories weren't just empty folders, but gateways to ready-to-develop environments? What if all you need to do is to ask to your powerful copilot without leaving your IDE? In this talk, we will show you how to use technologies such as GitHub Copilot and MCP servers, to allow any team to create, with a simple sentence, an entire project: standardized repositories, linters files, branch and security configuration, Docker files, environment variables, and more, all aligned with the platform and security team's golden paths. We will explore how to design these tools, integrate them into the developer's existing workflows, and ensure that every new project is born ready with what is needed to succeed. If you work in platform engineering, DevOps, or in-house development teams, this session will show you a new way to scale your impact. Could you commit a change into production on your first day of work? Let's work together to make it possible. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "intermediate",
    speakers: ["03255126-a9e1-4873-a5c4-d6ab97a6d207"],
    title: "Self-provisioning Platform Capabilities with a chat: GitHub Copilot and MCP",
    track: "Interactive 3-hour Hands-on Lab",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "Room 2",
    youtube: "",
    updated: "2025-06-16T10:10:05.490Z"
    ,
    order: 1
    ,
    conferenceDay: "day1"
    ,
    startTime: "09:00"
    ,
    endTime: "11:30"
    ,
    trackInDay: 2
}, {
    id: "cb3cfb24-a24d-4fac-b838-36590aea7d53",
    description: "Experience has become an expectation. Relevance is the new differentiator. Brand Brain is there to connect all conversational touchpoints enabling human like omni-channel interactions in a consistent brand tonality. Power by behavioural graph and a multi-agent system Brand Brain it's driving hyper relevance providing unique individual next best actions and recommendations.   ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["2251d145-b8e0-4bd5-a53c-5b8c91f54b76", "2c5c1370-d9f7-4a16-9ec9-3fd7c4f9690f", "affac4e0-f6b2-48e0-983b-1e0fa990462a"],
    title: "Brand Brain - relevance at scale",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/Dz6f20NrDv4",
    updated: "2025-08-21T11:35:04.344Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:00"
    ,
    endTime: "13:40"
    ,
    trackInDay: 2
}, {
    id: "6e4609d0-24bd-4b72-ab4f-59c8785d332a",
    description: "Running your very first ML model is beautiful and smooth… until you need to retrain it with different features. Or you realize months later that something’s off with its predictions. What if you decide to build a new product where you want to use dozens or even hundreds of models Developing ML products doesn’t have to mean weeks of waiting as the model slowly passes through the hands of researchers, developers and SREs. Many of these issues can be addressed by applying DevOps principles to machine learning — that’s where MLOps steps in.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["31fc111d-32a6-4813-a0d1-854e8fe00e3e"],
    title: "Solving the production ML chaos",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/S7J328NLfOc",
    updated: "2025-08-08T15:16:27.520Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:50"
    ,
    endTime: "16:30"
    ,
    trackInDay: 3
}, {
    id: "67560544-5991-476e-8060-50303ae6d1a9",
    description: "This hands-on workshop bridges the gap between conversational programming (“vibe coding“) and enterprise-grade cloud deployment using AWS's latest AI-powered development tools. Participants will learn to transform natural language descriptions into production-ready applications through practical exercises using Amazon Q Developer / Q CLI. The workshop demonstrates how to leverage AI-assisted development while maintaining AWS best practices for security, scalability, and cost optimization. Through guided exercises, attendees will experience firsthand how to prototype applications using natural language, debug with AI assistance, and deploy to AWS infrastructure. Ideal for developers seeking to enhance their productivity with AI-powered tools while building robust cloud-native applications. Prior basic knowledge of AWS services and software development is recommended.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "intermediate",
    speakers: ["f4d7cc2e-a9dc-4faf-9e46-94a803dff6c1"],
    title: "From Vibes to Cloud: Mastering AI-Assisted Development with AWS Tools",
    track: "Interactive 3-hour Hands-on Lab",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "Room 1",
    youtube: "",
    updated: "2025-09-16T14:16:34.825Z"
    ,
    order: 1
    ,
    conferenceDay: "day1"
    ,
    startTime: "15:00"
    ,
    endTime: "17:30"
    ,
    trackInDay: 1
}, {
    id: "e943bc0d-564b-4a59-8e27-5039e4ac5584",
    description: "This talk demonstrates a top-down approach to application development powered by GenAI tools like Cursor, Claude Code or GitHub Copilot. We'll cover defining functional and technical specifications, structuring an implementation plan with phases and tasks, and generating code phase by phase, task by task with AI.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "intermediate",
    speakers: ["3a14d41e-6c58-4c70-8664-df48cfdc5524"],
    title: "AI-Assisted App Development Journey",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/cBKt4B-rez4",
    updated: "2025-06-25T13:22:54.933Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:50"
    ,
    endTime: "14:30"
    ,
    trackInDay: 3
}, {
    id: "36a1717a-fda4-414c-8082-1398ae1424b6",
    description: "Leveraging GitHub Copilot can significantly accelerate the development of deep learning prototypes - provided one remains vigilant. In this talk, we will explore the advantages and potential challenges of assisted coding, using the detection of lung presence in CT images as a practical case study. Through this demonstration, we will highlight how Copilot can streamline development while also addressing key pitfalls to avoid.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["5ee716ee-311f-49ee-8c3a-fdf6cb8b693f"],
    title: "A Great Servant but a Bad Master - Deep Learning with GitHub Copilot",
    track: "10-minute Lightning Talk",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/OfPViL8hW2g",
    updated: "2025-08-14T07:39:02.730Z"
    ,
    order: 2
    ,
    conferenceDay: "day2"
    ,
    startTime: "10:30"
    ,
    endTime: "11:10"
    ,
    trackInDay: 6
},  {
    id: "a0025aa6-e05c-4b49-8690-ca53a202237a",
    description: "How can domain-driven design principles can accelerate enterprise transformation when paired with AI? Endpoint agents will increasingly need good sources of data and its context - Domain Driven Design gives us the framework to define data models in a consistent, consumable manner. The approach enables organizations to align technology with business domains, fostering agility and innovation. By embedding AI into domain services, enterprises can unlock contextual intelligence, automate decision-making, and scale solutions across business units. The session will show some real-world applications and the importance of cross-functional approach.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["021051c7-2943-4676-9c60-f143d030d9c2", "1bb35a1e-7735-4efc-840b-43b5059d3c6a"],
    title: "AI-enabled Future via Domain Driven Enterprise",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/Dy917VEAcj4",
    updated: "2025-09-10T14:32:18.472Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "11:20"
    ,
    endTime: "12:00"
    ,
    trackInDay: 3
}, {
    id: "4608586d-098e-430f-8051-75a418b650a7",
    description: "At Accenture The Dock we turn GenAI ideas into business wins—fast. First, an AI user-story assistant converts rough task notes into template-perfect tickets and prompts for any missing details, so project leads read a JIRA board and know the real status instantly—fewer gaps, shorter stand-ups, smoother sprints. Next, for Marketing Operations, we showcase a multilayer deepfake-detector that protects brand integrity before anything goes live. Eight AI “specialists” built on four complementary techniques—image-forensics ML, reverse-image searchers, metadata analyzers, and multimodal GenAI reviewers—scrutinize every picture. Their verdicts feed a GenAI “arbiter” that issues one clear ruling plus an audit trail, flagging AI-generated images for extra review and ensuring every public document meets policy. Two rapid prototypes, one common payoff: better data for decision-makers and compliance peace of mind, delivered at warp speed. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["9969e011-6c53-428d-b089-b4c1093fb4b9"],
    title: "GenAI at Warp Speed: From Storyboards to Deepfake Detectors",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/u8ytm01wIzQ",
    updated: "2025-07-16T15:58:04.195Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:00"
    ,
    endTime: "13:40"
    ,
    trackInDay: 5
}, {
    id: "f3673d86-c439-459d-a61c-cd3b9980c8fc",
    description: "During this talk I will share an update on how the Decentralized Identity world is progressing - who is adopting, what problems are they looking to solve, and what value is being realized - from cost savings to risk mitigation to revenue generation. I will bust some common myths about decentralized identity that often scare people away - namely that it is blockchain (which it is not), that its about identity (which is only partially true), and that it requires everything to be decentralized (which is absolutely not true). I will introduce the Universal Wallet Infrastructure, that we have been developing to help our clients to realize the true potential of a decentralized architecture as the rails on which personal data flows through a digital society.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["b6c9e111-a7c8-410e-9038-d3d8e0d15d38"],
    title: "The future of data will be decentralized",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/bG-O-VMbEyk",
    updated: "2025-08-12T09:48:07.741Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "10:30"
    ,
    endTime: "11:10"
    ,
    trackInDay: 5
}, {
    id: "5b2a9ec8-da9c-4db3-b8cb-3f96b804ff75",
    description: "What if your energy bill could shrink while your efficiency soars? For industrial clients and commercial buildings, energy is one of the biggest operating expenses—and one of the easiest places to save with the right tools. In this talk, we’ll explore how AI and real-time data unlock powerful opportunities to cut costs, reduce waste, and optimize performance. By continuously analyzing live energy usage, AI can detect inefficiencies, predict demand spikes, and automatically adjust systems to avoid expensive peaks. The result? Lower bills, improved sustainability, and fewer surprises. You’ll see how manufacturers, office towers, and large facilities are already slashing energy costs while meeting sustainability goals, and learn about practical solutions that don’t require massive upfront investment. Whether you manage a single site or a global portfolio, this session will show how AI-driven energy intelligence can keep your operations lean, efficient, and future-ready.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "expert",
    speakers: ["0afa31f1-e1c5-4fc9-8fc2-4e3861dbc7ef"],
    title: "What gets measured gets improved",
    track: "10-minute Lightning Talk",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/uJCsBZnciMM",
    updated: "2025-09-10T15:38:04.552Z"
    ,
    order: 3
    ,
    conferenceDay: "day2"
    ,
    startTime: "10:30"
    ,
    endTime: "11:10"
    ,
    trackInDay: 6
},  {
    id: "8466c0a6-70f5-439e-a45e-af7b6901df2a",
    description: "Real-time data processing in Apache Flink is an elegant, state-of-the-art choice. However, if you want to process larger volumes of data truly reliably, some mysterious phenomena start to appear... We'll discuss latecomers, nondeterminism, window settings, data skew, checkpointing, and other intricacies we've encountered over years of using Flink in the company. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "expert",
    speakers: ["bcf0d471-eadf-4996-b19a-c52921cb9655"],
    title: "Challenges and Specifics of Real-Time Data Processing in Apache Flink",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/5jOCwlnqwA8",
    updated: "2025-08-08T13:31:14.886Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "11:20"
    ,
    endTime: "12:00"
    ,
    trackInDay: 4
}, {
    id: "453c7680-77c9-474a-bfd3-d6d0a9a5122f",
    description: "The initial shock of the cognitive wave is over. Now, the strategic questions emerge. As we stand at the threshold of this new era, our panel discussion at OpenSlava 2025 will explore the profound implications of Agentic AI on our businesses, teams, and individual roles. Join Max Furmanov from Accenture, Adam Tybor from Confluent, and Viktoria Lukacova Brajcunova from AI robocube, as they debate the pragmatic next steps in cultivating ecosystems of intelligent agents, operating in an AI-collaborative environment, and redefining human expertise in an age of instant knowledge.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["46d558c7-28c2-48c7-b355-b1ec9ad9a2bb", "b40fa1dd-759e-4df6-af15-d7e006b5beb5", "fbe25268-f13c-44d5-9fcc-b919b72212e2"],
    title: "Panel Discussion: Navigating Autonomous AI Futures",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/1byC9Kua2H8",
    updated: "2025-09-26T13:42:48.819Z"
    ,
    order: 0
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:00"
    ,
    endTime: "14:30"
    ,
    trackInDay: 6
}, {
    id: "8478d689-4cf9-4617-8bda-e4bdfc90715d",
    description: "Over 20 years have passed since Pat Helland's seminal speech on Enterprise IT, “Metropolis: A Perspective on the Future of Distributed Systems“. In these 2 decades, Enterprise IT landscapes got more and more complex, thanks to Cloud and GenAI, and now completely interdependent with each other. Helland famously compared software systems to urban planning, drawing parallels between how cities evolve and how enterprise IT landscapes grow, become complex, and require better structure and governance. The metaphor is still very relevant, but now we are not just planning and managing cities (enterprise IT landscapes) anymore. We have whole countries. This requires even faster, more efficient governance and decision-making. How can we deal with the complexity at speed? This talk is specifically targeted a Technology and Business leaders and Enterprise Architects.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "expert",
    speakers: ["3e5197f2-60f8-4f13-a599-8374770e68e6"],
    title: "From Metropolis to the Global Village",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/kZrTy2zNIuc",
    updated: "2025-08-07T14:57:49.556Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "10:30"
    ,
    endTime: "11:10"
    ,
    trackInDay: 4
}, {
    id: "ea3c32dc-2d00-4322-9365-6c1d630f4150",
    description: "Join us for a live recording of Klik, Slovakia’s leading tech podcast, at OpenSlava. We will discuss intersection of trends in tech, AI and business, with a special guest appearance by Pavol Szorad, Cloud Advisory Managing Director at Accenture in the United States. This is your chance to be part of the conversation and experience the podcast in person. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["021051c7-2943-4676-9c60-f143d030d9c2", "830c5b58-84d8-48a9-9817-d66d4a2d8363"],
    title: "KLIK podcast by SME daily - public recording (in Slovak language)",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/0s_xzMiA_R0?si=6XZ8OWiChNlaTrEi",
    updated: "2025-09-22T14:15:22.947Z"
    ,
    order: 0
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:00"
    ,
    endTime: "15:40"
    ,
    trackInDay: 6
}, {
    id: "ddeff478-bbc9-42bf-95eb-f05e4197d6be",
    description: "The future of robotics lies in autonomy that goes beyond pre-programmed instructions. This talk explores how artificial intelligence is reshaping the way autonomous systems learn, adapt, and plan—moving from rigid, manually coded behaviors toward self-improving, intelligent agents. We will dive into the convergence of AI-driven planning, advanced robotics, humanoid systems, and digital twins to show how adaptive learning enables robots to make decisions in dynamic environments, making them not just tools but collaborative partners capable of learning, reasoning, and evolving with minimal human coding.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["75440e8c-1144-4846-911c-9ee8c6a89222", "8d031809-c0cd-4d2f-9cef-93be9347a593"],
    title: "Shaping the Future of Intelligent Autonomous Systems: Teaching or Coding?",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/DhfRu_r4wFI",
    updated: "2025-08-18T15:12:35.174Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "11:20"
    ,
    endTime: "12:00"
    ,
    trackInDay: 2
}, {
    id: "b551df52-2e09-4666-8cfc-b2becabd6819",
    description: "Automation is undergoing a radical shift. What began as simple rule-based bots is now evolving into intelligent, autonomous agents capable of reasoning, adapting, and making decisions in real time. This session dives into the transformation driven by Generative AI, uncovering how businesses are moving beyond traditional RPA to deploy AI agents that orchestrate complex processes with minimal human input. The presentation walks through the automation timeline, defines what truly differentiates agents from bots, and highlights real-world use cases across logistics, finance, HR, and operations. Attendees will gain insight into how AI agents are not only improving efficiency but also unlocking new business models and roles. The session also explores what this means for IT teams, future workforce planning, and how companies can prepare to implement agent-driven solutions. A must-attend for anyone seeking to understand or capitalize on the next phase of intelligent automation.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["fbe25268-f13c-44d5-9fcc-b919b72212e2"],
    title: "From Bots to Agents: The Evolution of Automation in the Age of GenAI",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/EFy7gwIY8gU",
    updated: "2025-08-06T11:20:44.917Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:50"
    ,
    endTime: "16:30"
    ,
    trackInDay: 1
}, {
    id: "6310c892-3749-4391-9804-3be272b46426",
    description: "Large language models are useful, creative, and knowledgeable—but they are also unreliable. At any moment, without warning, they can hallucinate and confidently produce information that is completely incorrect. Researchers have struggled for years to solve this critical problem. In just seven minutes, we will attempt what they have not been able to do: uncover the root cause of hallucinations and show how to eliminate them.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["5304f9e8-d4e4-4938-bc70-7eb0f672e17a"],
    title: "Why language models hallucinate",
    track: "10-minute Lightning Talk",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/BiA-tseznOw",
    updated: "2025-09-11T18:58:28.208Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "11:20"
    ,
    endTime: "12:00"
    ,
    trackInDay: 6
}, {
    id: "a1482ee6-4577-4d0a-b471-60d8a4252fa2",
    description: "AI is no longer just something for labs or pilot projects – it’s starting to compile the real physical world. Industry is investing billions into making AI work across tools, teams and physical systems. But while the hype is loud, some of the most important shifts are being overlooked. In this session, we will share three powerful trends that are quietly shaping the future of industrial AI – orchestration, physical AI, and AI UX. We’ll look at what these shifts mean for real business impact, and why now is the time to act. Based on what’s happening across engineering, manufacturing and operations - we will outline where the biggest opportunities lie for those building, leading or scaling AI initiatives. If you're working on strategy, transformation or delivery – this session will help you connect the dots.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["8f68106c-73b1-4292-b331-c80b8bca03c1"],
    title: "AI Compiling the World – What Industry Can Teach Us About the Next Wave of Intelligent Systems",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/wHkT7Tapt6I",
    updated: "2025-06-25T18:39:54.048Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "11:20"
    ,
    endTime: "12:00"
    ,
    trackInDay: 1
}, {
    id: "386ec42d-987c-4ccc-b42e-7875a31444b3",
    description: "In this talk, we will introduce quantum-based cryptosystems that are resistant to quantum computer attacks. We will describe their principles, describe the current state of quantum communication infrastructures and the remaining technological challenges associated with their implementation. We will also discuss some of the implemented use cases.  ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["8d1b9414-d9c2-49a5-abb9-82256fc0204d"],
    title: "Security of quantum-enabled networks",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/eSi7mqpT9UM",
    updated: "2025-09-07T22:03:17.557Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "10:30"
    ,
    endTime: "11:10"
    ,
    trackInDay: 2
}, {
    id: "f0f4fb9a-c327-46ea-9fae-5d1c9ac052bd",
    description: "Have you ever wondered if it is possible to work with large language models, LLMs, easily from Java code? It would be great to integrate seamlessly conversational-based capabilities into existing or new programs without having to learn a new language or platform. Challenges are multiple, like for example learning curves. As each service provider, local model, or vector database have different APIs, we have to learn every one of them as they are needed. Langchain4j is a library for the JVM that allows, through a common API based on intuitive patterns like 'builder', to easily create programs that interact with LLMs. In this talk, we will: - Introduce Langchain4j and take the first steps together. - Build some examples integrating a simple Java program with OpenAI. - Make changes to run local models with Ollama. - Create a more complex program to do RAG with a PDF document. Slides will be minimal and most of the talk will be live coding through the different scenarios. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: "beginner",
    speakers: ["03255126-a9e1-4873-a5c4-d6ab97a6d207"],
    title: "Langchain4j: Integrating LLMs with Java programs",
    track: "Interactive 3-hour Hands-on Lab",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "Room 2",
    youtube: "",
    updated: "2025-06-16T10:10:49.253Z"
    ,
    order: 1
    ,
    conferenceDay: "day1"
    ,
    startTime: "12:00"
    ,
    endTime: "14:30"
    ,
    trackInDay: 2
}, {
    id: "2035a331-6400-4ec9-93b9-c737c8e888b6",
    description: "Delivering Generative AI in the public sector brings unique challenges. This talk shares how a hybrid RAG system was built with guardrails, evaluation loops, and a production-ready serving stack. It covers the practical choices around models, infrastructure, and data, and how the system adapts to the rapidly changing GenAI ecosystem.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["540cb0b7-19ce-4404-a661-45c3c93ca9c8"],
    title: "Productionizing Sovereign GenAI: Hybrid RAG in the Public Sector",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/AONRBfr8SMU",
    updated: "2025-10-08T11:15:55.593Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:50"
    ,
    endTime: "16:30"
    ,
    trackInDay: 2
},  {
    id: "3fd550f8-8bea-4ddf-adc7-68fb3661aa3d",
    description: "Agentic AI is reshaping the enterprise landscape-transforming software from static applications into dynamic, intelligent agents that interact through natural language and deliver outcomes at unprecedented speed and scale. This keynote explores how Agentic systems are redefining business operations, enterprise architecture, and workforce models across industries. From banking and logistics to healthcare and energy, organizations are navigating a generational shift driven by composable architectures, real-time data integration, and AI-native operating models. We will discuss insights into the strategic opportunities of Agentic AI, including its impact on legacy systems, governance, cybersecurity, and compliance. The session will also highlight success criteria for implementation, the evolving role of developers, and the convergence of business, data, and technology into systems of trust. With real-world use cases and forward-looking perspectives, this keynote offers a roadmap for leaders to harness disruption, accelerate innovation, and build resilient, future-ready enterprises.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["b40fa1dd-759e-4df6-af15-d7e006b5beb5"],
    title: "The Agentic AI Revolution: Reimagining Enterprise Architecture and Workforce",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/iwq7EKYD3x8",
    updated: "2025-08-12T19:50:56.698Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "09:00"
    ,
    endTime: "09:30"
    ,
    trackInDay: 1
}, {
    id: "8ccf5e5b-0413-4679-86bd-0c936ac0faa1",
    description: "Flying cars bring new dimension into personal transportation. Development of the concept - from idea to realization. Changes in strategy of development of complex idea into working prototype. Impact of flying cars on general aviation segment.  ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["bcaa712f-43e8-4e2e-8c0e-a3aafb5680e2"],
    title: "Flying Car - Alternative Personal Transportation",
    track: "10-minute Lightning Talk",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/tlAoXZPGDnk",
    updated: "2025-09-18T14:05:36.981Z"
    ,
    order: 2
    ,
    conferenceDay: "day2"
    ,
    startTime: "11:20"
    ,
    endTime: "12:00"
    ,
    trackInDay: 6
}, {
    id: "8c353f36-2123-4796-a30d-f1366ff5cd9c",
    description: "This presentation explores the transformative potential of Agentic AI within the ServiceNow platform, moving beyond traditional automation to autonomous, goal-oriented systems. It would highlight how Agentic AI can revolutionize enterprise workflows by enabling AI agents to independently analyze data, make decisions, and execute tasks across IT, HR, customer service, and other business functions. The session would likely discuss the shift from humans using AI to humans managing fleets of AI agents, thereby significantly enhancing productivity, reducing manual effort, and driving business transformation. What is Agentic AI and why Agentic AI for, ServiceNow? Practical Applications and Use Cases, Building and Managing AI Agents, Challenges and Best Practices",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["0fa0a002-3887-4209-8e1d-c2173930c53a", "6a3a376e-c87f-45c1-a235-60f59298c089"],
    title: "Agentic AI & ServiceNow: Because Your To-Do List Isn't Going to Automate Itself (Unless We Help It)",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/hLo6IBqi6MI",
    updated: "2025-07-25T12:27:15.841Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:00"
    ,
    endTime: "15:40"
    ,
    trackInDay: 4
}, {
    id: "4eb25b8b-4068-426d-8552-8cbe804bf275",
    description: "We began with a “greenfield” vision: a clean slate, compliant legislation, polished COTS, clear requirements, and sleek mockups. But as the project evolved, so did the reality. Laws were drafted with tight timelines and high specificity; a product was selected that didn’t quite fit; requirements were written without full alignment to the product; mockups diverged from both. Teams drifted, scope shifted, and we found ourselves navigating a maze of contradictions. This talk embraces the complexity and offers a practical toolkit for navigating it. You’ll learn how to question assumptions, surface constraints early, and build lightweight but consistent alignment rituals that connect legislation, requirements, UX, and COTS to real-world delivery. Expect checklists, “alignment tripwires,” and conversation patterns for engaging executives, vendors—and even your own biases. No heavy theory—just reusable tactics. If you’ve ever asked, “When did we decide that?”, join us to reflect, recalibrate, and leave better equipped to protect architecture from drift and disconnection. Templates included. Theory slides not.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "intermediate",
    speakers: ["32bdaf26-220c-4e36-acd7-a177ae9219d9", "e513519e-497d-4792-8aca-d14343c555f3"],
    title: "Greenfield Dreams, Bureaucratic Realities",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/HCumLIjeEwA",
    updated: "2025-07-29T07:22:06.436Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "15:00"
    ,
    endTime: "15:40"
    ,
    trackInDay: 2
}, {
    id: "3baaa45f-2df6-4354-86c0-fd17d9a478db",
    description: "In this 10-minute introduction, we’ll explore the basics of accessibility in digital design. You’ll learn why accessibility matters, see the most common pitfalls that create barriers for users, and discover simple, practical fixes you can start applying right away. From color contrast and alt text to clear labels and better navigation, this session will give you quick wins to make your designs more inclusive for everyone.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "beginner",
    speakers: ["06eeb599-0c92-4211-b6f9-0defe5e275f8"],
    title: "Accessibility 101: Designing for everybody",
    track: "10-minute Lightning Talk",
    type: "talk",
    technicalOrBusiness: "business",
    time: "",
    room: "",
    youtube: "https://youtu.be/-srme2VIscM",
    updated: "2025-10-14T08:13:12.892Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "10:30"
    ,
    endTime: "11:10"
    ,
    trackInDay: 6
}, {
    id: "e8c5684c-c1b7-4c2a-a0bd-e2c603270b9a",
    description: "The only constant in life is change. Once again it seems that new era is coming. This time hitting us, software developers and architects. Are we prepared? Can AI do our job better? Software developers of new era need to step out of their comfort zone and learn how to use the AI as a tool which will help us to be more effective. It can even bring more joy to our daily life as we can get rid of repetitive, boring work and can fully concentrate on the essence - the creative work and mastering the craft of software engineering. This talk will help participants to understand why AI can not replace software engineers who can master their job and how SW Craft can help them to become the leaders in AI era even in such tightly regulated domain as Medical Device SW Development",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: "everyone",
    speakers: ["39beeaa9-1423-4aad-9e0c-6a34ebf4557e"],
    title: "The Software Crafter in the upcoming AI Era of Software Engineering",
    track: "40-minute Talk (30min+10min Q&A)",
    type: "talk",
    technicalOrBusiness: "technical",
    time: "",
    room: "",
    youtube: "https://youtu.be/rea1DcbAYEw",
    updated: "2025-08-13T12:33:04.086Z"
    ,
    order: 1
    ,
    conferenceDay: "day2"
    ,
    startTime: "13:00"
    ,
    endTime: "13:40"
    ,
    trackInDay: 3
}];

export default talks;
